import Header from './Components/Header';
import Home from './Pages/Home';
import Services from './Pages/Services'
import Projets from './Pages/Projets';
import Blog from './Pages/Blog'
import Article from './Pages/Article';
import { BrowserRouter,Route,Routes } from 'react-router-dom';
function App() {
  return (
    <div className='App'>
        <BrowserRouter>
      <Header/>
      <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/services' element={<Services/>}/>
          <Route path='/projets' element={<Projets/>}/>
          <Route path='/blog' element={<Blog/>}/>
          <Route path="/articles/:name" element={<Article/>}/>
          </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
